import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-notify-users-ride',
  templateUrl: './notify-users-ride.component.html',
  styleUrls: ['./notify-users-ride.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class NotifyUsersRideDialog implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { deleted: boolean }) {}

  ngOnInit() {}
}
